import { connect } from 'react-redux';
import React from 'react';
import { bindActionCreators } from 'redux';
import { Field, formValueSelector, reduxForm } from 'redux-form';
import { apiCallFailure, successState } from 'app/actions';
import {
KBInput,
KBFormError,
KBButton } from
'components';
import { api } from 'app/services';
import { Input, Row, Col, DatePicker, Modal, Space } from 'antd';
import dayjs from 'utils/dayjs';
import locale from 'antd/es/date-picker/locale/zh_CN';
import validator from 'validator';
import { getServiceErrorMessage } from 'utils/kbUtil';

const MIN_FINAL_PRICE = 2;
const getFinalPrice = (price, discountPrice) => {
  return Number(price) - Math.abs(Number(discountPrice || 0));
};
const hasValidBasePrice = price => Number.isFinite(Number(price)) && Number(price) > 0;
const { RangePicker } = DatePicker;
const PREVIEW_SHOW_TIME = {
  defaultValue: dayjs('00', 'HH'),
  format: 'HH' };
const getQuarterRange = (date = dayjs(), offset = 0) => {
  const quarterStartMonth = Math.floor(date.month() / 3) * 3;
  const start = date.month(quarterStartMonth).startOf('month').add(offset * 3, 'months');
  return [start, start.add(2, 'months').endOf('month')];
};
const keepPickerPanelFocus = event => {
  event.preventDefault();
};
const renderPickerPanel = panel => {
  return <div onMouseDown={keepPickerPanelFocus}>{panel}</div>;
};

class CompositionSafeTextArea extends React.Component {constructor(props) {super(props);this.isComposing = false;this.state = { value: props.input.value || '', composing: false };this.handleChange = this.handleChange.bind(this);this.handleCompositionStart = this.handleCompositionStart.bind(this);this.handleCompositionEnd = this.handleCompositionEnd.bind(this);}componentDidUpdate(prevProps) {
    if (
    !this.state.composing &&
    this.props.input.value !== prevProps.input.value &&
    this.props.input.value !== this.state.value)
    {
      this.setState({ value: this.props.input.value || '' });
    }
  }handleChange(

  event) {
    const value = event.target.value;
    this.setState({ value });
    if (!this.isComposing) {
      this.props.input.onChange(value);
    }
  }handleCompositionStart()

  {
    this.isComposing = true;
    this.setState({ composing: true });
  }handleCompositionEnd(

  event) {
    const value = event.target.value;
    this.isComposing = false;
    this.setState({
      value,
      composing: false });

    this.props.input.onChange(value);
  }render()
  {
    const { input, meta, ...props } = this.props;
    return (
      <Input.TextArea
      {...props}
      value={this.state.value}
      onChange={this.handleChange}
      onCompositionStart={this.handleCompositionStart}
      onCompositionEnd={this.handleCompositionEnd} />);

  }}

let SettingCoupon = class extends React.Component {constructor(props) {super(props);this.pickerValueCache = {};this.rangePickerValueCache = { start: undefined, end: undefined, value: [null, null] };this.datePresetsCache = { day: null, presets: [] };this.createAreaForm = this.createAreaForm.bind(this);this.changeDate = this.changeDate.bind(this);this.changePrice = this.changePrice.bind(this);this.getPickerValue = this.getPickerValue.bind(this);this.getRangePickerValue = this.getRangePickerValue.bind(this);this.getDatePresets = this.getDatePresets.bind(this);this.renderInputField = this.renderInputField.bind(this);this.renderErrorField = this.renderErrorField.bind(this);this.renderHiddenField = this.renderHiddenField.bind(this);this.renderTextAreaField = this.renderTextAreaField.bind(this);}componentDidMount()
  {
    // dayjs.locale('zh-cn');
  }createAreaForm(
  model) {
    const { close, type, callback, apiCallFailureActions, successAction } = this.props;
    let params = {};
    if (type === 'add') {
      params = {
        title: model.title,
        start_date: model.start_date,
        end_date: model.end_date,
        source_id: model.source_id,
        source_type: 'Area',
        discount_price: -model.discount_price,
        preview_start_at:
        model.preview_start_at || dayjs().format('YYYY-MM-DD HH'),
        discount_tenant_price: -model.discount_tenant_price,
        discount_bridge_price: -model.discount_bridge_price,
        note: model.note };

      api.createCoupon(params).then(
      res => {
        successAction({ message: '添加成功' });
        close && close();
      },
      error => {
        if (error) {
          apiCallFailureActions({
            status: 'error',
            title: '添加失败',
            message: getServiceErrorMessage(error) || error.message });
          // close && close()
        }
      });

    } else if (type === 'edit') {
      params = {
        title: model.title,
        start_date: model.start_date,
        end_date: model.end_date,
        preview_start_at: model.preview_start_at,
        note: model.note,
        on_sales: true };

      callback && callback(params);
    }
  }changeDate(
  date) {
    const { change } = this.props;
    if (!date) {
      change('start_date', '');
      change('end_date', '');
      return;
    }
    const [startDate, endDate] = date;
    // const { from, to } = range
    const start = dayjs(startDate).format('YYYY-MM-DD');
    const end = dayjs(endDate).format('YYYY-MM-DD');
    change('start_date', start);
    change('end_date', end);

  }getPickerValue(
  value) {
    if (!value) {
      return null;
    }
    const key = String(value);
    if (this.pickerValueCache[key]) {
      return this.pickerValueCache[key];
    }
    const next = dayjs(value);
    if (!next.isValid()) {
      return null;
    }
    this.pickerValueCache[key] = next;
    return next;
  }getRangePickerValue(
  start, end) {
    if (
    this.rangePickerValueCache.start === start &&
    this.rangePickerValueCache.end === end)
    {
      return this.rangePickerValueCache.value;
    }
    const value = [this.getPickerValue(start), this.getPickerValue(end)];
    this.rangePickerValueCache = {
      start,
      end,
      value };

    return value;
  }getDatePresets()
  {
    const day = dayjs().format('YYYY-MM-DD');
    if (this.datePresetsCache.day === day) {
      return this.datePresetsCache.presets;
    }
    const now = dayjs();
    const presets = [
    { label: '本周', value: [now.startOf('week'), now.endOf('week')] },
    { label: '本月', value: [now.startOf('month'), now.endOf('month')] },
    { label: '本季度', value: getQuarterRange(now) },
    {
      label: '下月',
      value: [now.add(1, 'months').startOf('month'), now.add(1, 'months').endOf('month')] },

    {
      label: '下季度',
      value: getQuarterRange(now, 1) }];

    this.datePresetsCache = {
      day,
      presets };

    return presets;
  }changePrice(
  value, fieldName, type) {
    const { change, formValues = {}, apiCallFailureActions } = this.props;
    if (value && !validator.isNumeric(value)) {
      return apiCallFailureActions({ status: 'error', message: '请输入数字' });
    }
    change(fieldName, value);

    if (type === '1') {
      change('real_price', getFinalPrice(formValues.price, value));
    }
    if (type === '2') {
      change('real_tenant_price', getFinalPrice(formValues.tenant_price, value));
    }
    if (type === '3') {
      change('real_bridge_price', getFinalPrice(formValues.bridge_price, value));
    }

  }renderInputField(

  { input, meta, ...props }) {
    const field = {
      ...input,
      touched: meta.touched,
      error: meta.error };
    return <KBInput field={field} {...props} />;
  }renderErrorField(

  { meta }) {
    return meta.touched && meta.error ? <p className="lr-error">{meta.error}</p> : null;
  }renderHiddenField(

  { input }) {
    return <input {...input} type="hidden" />;
  }renderTextAreaField(

  props) {
    return <CompositionSafeTextArea {...props} />;
  }renderPriceInput(
  { before, after = '元/时', ...props }) {
    return (
      <Space.Compact style={{ display: 'flex', width: '100%' }}>
        {before ? <Input value={before} disabled style={{ flex: '0 0 36px', width: 36, textAlign: 'center' }} /> : null}
        <Input {...props} style={{ flex: 1, minWidth: 0 }} />
        {after ? <Input value={after} disabled style={{ flex: '0 0 64px', width: 64, textAlign: 'center' }} /> : null}
      </Space.Compact>);

  }render()
  {
    const {
      data = {},
        open,
      close,
      type,
      callback,
      handleSubmit,
      submitting,
      formValues = {} } =

    this.props;
    return (
      <Modal
      open={open}
      title={type === 'add' ? '增加促销活动' : '编辑促销活动'}
      width="800"
      onCancel={close}
      footer={null}
      destroyOnHidden
      centered>

        <form onSubmit={handleSubmit(this.createAreaForm)}>
          {[
          'source_id',
          'source_type',
          'price',
          'tenant_price',
          'bridge_price',
          'real_price',
          'real_tenant_price',
          'real_bridge_price'].
          map(name => (
            <Field
            key={name}
            name={name}
            component={this.renderHiddenField} />))}

          <KBFormError error={this.props.error} />
          <div className="kb-form-container">
            <div className="kb-row">
              <Field
              name="title"
              component={this.renderInputField}
              className="kb-form-group kb-form-c18 kb-form-alone"
              title="优惠名称"
              label
              isRequired={true}
              fistFoucs={true}
              placeholder="范例：开业促销" />

            </div>
            <div className="kb-row">
              <div>
                <label style={{ position: 'relative' }}>
                  <span
                  style={{
                    position: 'absolute',
                    color: '#F62D51',
                    top: 3,
                    left: -8 }}>


                    *
                  </span>
                  预订日期
                </label>
                <div>
                  <RangePicker
                  value={this.getRangePickerValue(formValues.start_date, formValues.end_date)}
                  onChange={this.changeDate}
                  panelRender={renderPickerPanel}
                  presets={this.getDatePresets()} />



                  {/* <KBRangeDate
                     title="选择日期范围"
                     format="YYYY/MM/DD"
                     from={start_date.value || ''}
                     to={end_date.value || ''}
                     callback={this.changeDate}
                     leftNone={true}
                    /> */}
                </div>
                <Field
                name="start_date"
                component={this.renderErrorField} />
                <Field
                name="end_date"
                component={this.renderHiddenField} />
              </div>
            </div>

            <div className="kb-row">
              <div className="kb-form-c18 kb-form-group kb-form-alone">
                <label>
                  提前预览时间<span className="must-fill">*</span>
                </label>
                <div>
                  <DatePicker
                  locale={locale}
                  format="YYYY-MM-DD HH:mm"
                  value={this.getPickerValue(formValues.preview_start_at)}
                  panelRender={renderPickerPanel}
                  showTime={PREVIEW_SHOW_TIME}

                  onChange={value => {
                    if (value) {
                      const date = dayjs(value).format('YYYY-MM-DD HH:mm');
                      this.props.change('preview_start_at', date);
                    } else {
                      this.props.change('preview_start_at', '');
                    }
                  }} />

                  <Field
                  name="preview_start_at"
                  component={this.renderErrorField} />
                </div>
              </div>
            </div>
            {/* {source_type.value === 'meeting' && ( */}
            <div style={{ marginTop: 10 }}>
              <Row align="middle" justify="space-between">
                <Col span={6}>
                  <label>一般价格</label>
                  <div>
                    {this.renderPriceInput({ value: formValues.price, disabled: true })}
                    <p style={{ fontSize: 12, color: '#c6c6c6' }}>针对所有注册成为凯德星会员的会员购买的价格</p>
                  </div>
                </Col>
                <Col span={6} offset={1}>
                  <label>办公楼会员价</label>
                  <div>
                    {this.renderPriceInput({
                    value: formValues.tenant_price,
                    disabled: true })}

                    <p style={{ fontSize: 12, color: '#c6c6c6' }}>在本系统中登记的会员预定价格</p>
                  </div>
                </Col>
                <Col span={6} offset={1}>
                  <label>奕桥会员价</label>
                  <div>
                    {this.renderPriceInput({
                    value: formValues.bridge_price || 0,
                    disabled: true })}

                    <p style={{ fontSize: 12, color: '#c6c6c6' }}>所属公司有联办合同的会员预定是使用的价格</p>
                  </div>
                </Col>
              </Row>

              <div
              style={{ fontSize: 16, color: '#8d8d8d', marginTop: 10 }}>

                优惠额度
              </div>
              <Row align="middle" justify="space-between">
                <Col span={6}>
                  <label>一般价格</label>
                  <div>
                    {this.renderPriceInput({
                    disabled: type === 'edit' ? true : false,
                    value: formValues.discount_price,
                    onChange: e =>
                    this.changePrice(e.target.value, 'discount_price', '1'),
                    before: '-' })}

                  </div>
                  <Field
                  name="discount_price"
                  component={this.renderErrorField} />
                </Col>
                <Col span={6} offset={1}>
                  <label>办公楼会员价</label>
                  <div>
                    {this.renderPriceInput({
                    disabled: type === 'edit' ? true : false,
                    value: formValues.discount_tenant_price,
                    onChange: e =>
                    this.changePrice(
                    e.target.value,
                    'discount_tenant_price',
                    '2'),
                    before: '-' })}

                  </div>
                  <Field
                  name="discount_tenant_price"
                  component={this.renderErrorField} />
                </Col>
                <Col span={6} offset={1}>
                  <label>奕桥会员价</label>
                  <div>
                    {this.renderPriceInput({
                    disabled: type === 'edit' ? true : false,
                    value: formValues.discount_bridge_price,
                    onChange: e =>
                    this.changePrice(
                    e.target.value,
                    'discount_bridge_price',
                    '3'),
                    before: '-' })}

                  </div>
                  <Field
                  name="discount_bridge_price"
                  component={this.renderErrorField} />
                </Col>
              </Row>

              <div
              style={{ fontSize: 16, color: '#8d8d8d', marginTop: 10 }}>

                最终价格
              </div>
              <Row align="middle" justify="space-between">
                <Col span={6}>
                  <div>一般价格</div>
                  <div>
                    {this.renderPriceInput({
                    value: formValues.real_price,
                    disabled: true })}

                  </div>
                </Col>
                <Col span={6} offset={1}>
                  <div>办公楼会员价</div>
                  <div>
                    {this.renderPriceInput({
                    value: formValues.real_tenant_price,
                    disabled: true })}

                  </div>
                </Col>
                <Col span={6} offset={1}>
                  <div>奕桥会员价</div>
                  <div>
                    {this.renderPriceInput({
                    value: formValues.real_bridge_price,
                    disabled: true })}

                  </div>
                </Col>
              </Row>
            </div>
            <div style={{ marginTop: 20 }}>
              <label>备注</label>
              <Field name="note" component={this.renderTextAreaField} />

            </div>
            <div className="kb-row fixed-form-btn">
              <span
              className="cancel-btn"
              onClick={() => {
                close && close();
              }}>

                取消
              </span>
              <KBButton
              className="certain-btn"
              type="submit"
              submitting={submitting}>

                保存
              </KBButton>
            </div>
          </div>
        </form>
      </Modal>);

  }};


function mapStateToProps(state, props) {
  const { source_type, params = {}, data = {}, type } = props;
  const selector = formValueSelector('SettingCoupon');

  let values = { source_type };
  if (type === 'edit' && Object.keys(data).length) {
    values = {
      id: data.id,
      start_date: dayjs(data.start_date).format('YYYY-MM-DD'),
      end_date: dayjs(data.end_date).format('YYYY-MM-DD'),
      preview_start_at: dayjs.
      unix(data.preview_start_at).
      format('YYYY-MM-DD HH:mm'),
      discount_price: Math.abs(data.discount_price),
      price: data.price,
      real_price: getFinalPrice(data.price, data.discount_price),
      title: data.title,
      source_type,
      discount_bridge_price: Math.abs(data.discount_bridge_price),
      discount_tenant_price: Math.abs(data.discount_tenant_price),
      bridge_price: data.bridge_price,
      tenant_price: data.tenant_price,
      real_tenant_price: getFinalPrice(
      data.tenant_price,
      data.discount_tenant_price),

      real_bridge_price: getFinalPrice(
      data.bridge_price,
      data.discount_bridge_price),

      note: data.note || '' };

  } else if (type === 'add' && data && Object.keys(data).length) {
    values = {
      start_date: dayjs().format('YYYY-MM-DD'),
      end_date: dayjs().format('YYYY-MM-DD'),
      preview_start_at: dayjs().
      subtract(1, 'days').
      startOf('hour').
      format('YYYY-MM-DD HH:mm'),
      source_id: data.id || '',
      source_type };

    if (source_type === 'meeting') {
      values = {
        ...values,
        price: data.non_entering_listing_price,
        bridge_price: data.bridge_listing_price,
        tenant_price: data.listing_price };

    } else {
      values = {
        ...values,
        price: data.non_entering_day_listing_price,
        bridge_price: data.bridge_listing_price,
        tenant_price: data.day_listing_price };

    }
  }
  return {
    initialValues: values,
    formValues: selector(
    state,
    'title',
    'start_date',
    'end_date',
    'preview_start_at',
    'price',
    'tenant_price',
    'bridge_price',
    'discount_price',
    'discount_tenant_price',
    'discount_bridge_price',
    'real_price',
    'real_tenant_price',
    'real_bridge_price',
    'source_type',
    'source_id',
    'note') };

}

function mapDispatchToProps(dispatch) {
  return {
    apiCallFailureActions: bindActionCreators(apiCallFailure, dispatch),
    successAction: bindActionCreators(successState, dispatch) };

}

const validate = values => {
  const errors = {};
  if (!values.title) errors.title = '请输入优惠名称';
  if (!values.start_date) errors.start_date = '选请择预定日期';
  if (!values.end_date) errors.start_date = '选请择预定日期';
  if (!values.preview_start_at) errors.preview_start_at = '选请择提前预览日期';
  validateDiscountPrice(
  errors,
  values,
  'price',
  'discount_price',
  '一般价格');
  validateDiscountPrice(
  errors,
  values,
  'tenant_price',
  'discount_tenant_price',
  '办公楼会员价');
  validateDiscountPrice(
  errors,
  values,
  'bridge_price',
  'discount_bridge_price',
  '奕桥会员价');
  if (
  values.start_date &&
  values.preview_start_at &&
  dayjs(values.preview_start_at).isAfter(dayjs(values.start_date)))

  errors.preview_start_at = `请选择小于${dayjs(values.start_date).format(
  'YYYY-MM-DD HH:mm')
  }的日期`;
  return errors;
};

function validateDiscountPrice(errors, values, priceKey, discountKey, label) {
  const discountValue = values[discountKey];
  if (!hasValidBasePrice(values[priceKey])) {
    errors[discountKey] = `请先配置${label}`;
    return;
  }

  if (discountValue === undefined || discountValue === null || discountValue === '') {
    errors[discountKey] = `请输入${label}优惠额度`;
    return;
  }

  if (!validator.isNumeric(String(discountValue))) {
    errors[discountKey] = `请输入正确的${label}优惠额度`;
    return;
  }

  if (Number(discountValue) < 0) {
    errors[discountKey] = `${label}优惠额度不能小于0`;
    return;
  }

  if (getFinalPrice(values[priceKey], discountValue) < MIN_FINAL_PRICE) {
    errors[discountKey] = `${label}优惠后价格不能低于${MIN_FINAL_PRICE}元`;
  }
}

const formConfig = {
  form: 'SettingCoupon',
  validate: validate,
  touchOnBlur: false,
  enableReinitialize: true };

SettingCoupon = reduxForm(formConfig)(SettingCoupon);

export default connect(mapStateToProps, mapDispatchToProps)(SettingCoupon);
